import { mount, unmount } from 'src/modules/Distances/components/shared/Steps/GPX/actions';
import { openCheckPointsModalStore } from 'src/modules/Distances/components/shared/Steps/GPX/stores';

export const closeModal = () => {
  openCheckPointsModalStore.off();
  unmount();
  mount();
};
